import StorageService from '@services/storage.service';

export default { // data
    superadminLoggedSchool: StorageService.getItem('superadminLoggedSchool', true, true) || false,
    districtLoggedSchool: StorageService.getItem('districtLoggedSchool', true, true) || false,
}
